import React, { useEffect } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NavigateNext from '@material-ui/icons/NavigateNext';
import { Redirect, Link, useParams } from 'react-router-dom';

import headerBackground from '../Images/header-background.png';
import Footer from '../components/Footer';
import PaymentActions from '../../../state/actions/PaymentActions';
import { getError } from '../../../state/reducers/PaymentReducer';
import { getQuote, isFetching } from '../../../state/reducers/PaymentReducer';

let styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    minWidth: 350,
    maxWidth: 1000,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleStyle: {
    color: '#ffffff',
    fontWeight: 'bold',
  },
  subTitle: {
    color: '#FF0F0C',
    fontWeight: 'bold',
  },
  warningText: {
    color: '#FF0F0C',
  },
  buttonApplications: {
    fontWeight: 'bold',
    color: '#F9F9F9',
    backgroundColor: '#2a3eb1',
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.1),
    paddingBottom: theme.spacing(1.1),
    fontSize: 18,
  },
  itemMidContainer: {
    marginTop: theme.spacing(10),
  },
  loading: {
    color: '#e0e0e0',
  },
  centered: {
    height: '100%',
    position: 'absolute',
  },
});

let sectionStyle = {
  height: '345px',
  backgroundImage: `url(${headerBackground})`,
};

function PaymentNotSuccessful(props) {
  let {
    classes,
    error,
    isFetching,
    quote,
    getPaymentInfoRequest,
    submitPaymentRequest,
  } = props;
  let { uuid } = useParams();
  let { t } = useTranslation();

  useEffect(() => {
    if (uuid) {
      getPaymentInfoRequest(uuid);
    }
  }, [getPaymentInfoRequest, uuid]);

  useEffect(() => {
    if (quote && quote.paymentProvider.name === 'SaferPay') {
      submitPaymentRequest(quote.uuid, 'FAILED');
    }
  }, [submitPaymentRequest, quote]);

  if (!uuid) {
    return <Redirect to={'/applications'} />;
  }

  if (isFetching) {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="row"
        classes={{ container: classes.centered }}
      >
        <Typography className={classes.loading} variant="h5" align="center">
          {t('pleaseWait')}
        </Typography>
      </Grid>
    );
  }

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        direction="row"
      >
        <Grid
          className={classes.headerContainer}
          style={sectionStyle}
          item
          xs={12}
        >
          <Typography
            className={classes.titleStyle}
            variant="h3"
            align="center"
            gutterBottom
          >
            {t('onlineServices')}
          </Typography>
        </Grid>
        <Grid className={classes.itemMidContainer}>
          <Paper className={classes.root} elevation={3}>
            <Typography
              className={classes.subTitle}
              align="center"
              variant="h4"
            >
              {t('paymentNotSuccessful')}
            </Typography>
            <Typography className={classes.warningText} variant="h5">
              {error}
            </Typography>
          </Paper>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            direction="row"
          >
            <Button
              variant="contained"
              className={classes.buttonApplications}
              component={Link}
              to="/applications"
            >
              {t('goToApplications')}
              <NavigateNext className={classes.rightIcon} />
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
}

let { submitPaymentRequest, getPaymentInfoRequest } = PaymentActions;

export default compose(
  withStyles(styles),
  connect(
    (s) => ({
      error: getError(s),
      quote: getQuote(s),
      isFetching: isFetching(s),
    }),
    { submitPaymentRequest, getPaymentInfoRequest }
  )
)(PaymentNotSuccessful);



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/PaymentFailure.js